module.exports = __webpack_public_path__ + "media/american-coot-2.ad6ae859.mp3";